import CompetitorAlternativePage from '@/components/Pages/CompetitorAlternativePage';
import { GALAXY_AI_ALTERNATIVE } from '@/constants/competitorAlternatives';

export default function GalaxyAiAlternativePage() {
  return (
    <CompetitorAlternativePage
      title="Galaxy AI Alternative (Now Magica) — Every Model"
      description="A Galaxy AI alternative — the product now called Magica. GPT, Claude, Gemini, Grok, and Arya in one private workspace, with images, video, music, and an API."
      canonical="/galaxy-ai-alternative"
      keywords="Galaxy AI alternative, galaxy.ai alternative, alternative to Galaxy AI, Magica alternative, Magica AI alternative, Galaxy AI competitor, apps like Galaxy AI, free Galaxy AI alternative, best Galaxy AI alternative"
      page={GALAXY_AI_ALTERNATIVE}
    />
  );
}
